import { ProductList } from '../../ProductList';

export const TransportationList: React.FC = () => (
  <ProductList resource="transportation" />
);
